
export default {
    name: 'LeeNotification',
    data() {
        return {
        }
    }
};
